interface EmailIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const EmailIcon = ({ width = 14, height = 14, className }: EmailIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath={`url(#clip0_550_9760)`}>
      <path
        d="M10.7917 0.583008H3.20833C2.35771 0.583934 1.5422 0.922252 0.940722 1.52373C0.339244 2.12521 0.000926432 2.94072 0 3.79134L0 10.208C0.000926432 11.0586 0.339244 11.8741 0.940722 12.4756C1.5422 13.0771 2.35771 13.4154 3.20833 13.4163H10.7917C11.6423 13.4154 12.4578 13.0771 13.0593 12.4756C13.6608 11.8741 13.9991 11.0586 14 10.208V3.79134C13.9991 2.94072 13.6608 2.12521 13.0593 1.52373C12.4578 0.922252 11.6423 0.583934 10.7917 0.583008ZM10.7917 2.33301C11.1454 2.33419 11.4865 2.46516 11.7501 2.70109L7.95842 6.49276C7.70088 6.73873 7.35846 6.87598 7.00233 6.87598C6.64621 6.87598 6.30378 6.73873 6.04625 6.49276L2.25458 2.70109C2.51699 2.46623 2.85617 2.33532 3.20833 2.33301H10.7917ZM10.7917 11.6663H3.20833C2.82156 11.6663 2.45063 11.5127 2.17714 11.2392C1.90365 10.9657 1.75 10.5948 1.75 10.208V4.67626L4.80608 7.73234C5.09411 8.02049 5.43608 8.24907 5.81247 8.40503C6.18886 8.56098 6.59229 8.64125 6.99971 8.64125C7.40713 8.64125 7.81055 8.56098 8.18694 8.40503C8.56333 8.24907 8.90531 8.02049 9.19333 7.73234L12.25 4.67626V10.208C12.25 10.5948 12.0964 10.9657 11.8229 11.2392C11.5494 11.5127 11.1784 11.6663 10.7917 11.6663Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_550_9760">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EmailIcon;
